import { ClinicMapLocation } from '@chiroup/core/types/ClinicMapLocation.type';
import L from 'leaflet';
import 'leaflet.heat';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

interface HeatmapLayerProps {
  locations: ClinicMapLocation[];
  radius?: number;
  blur?: number;
  maxZoom?: number;
  max?: number;
  minOpacity?: number;
  gradient?: Record<number, string>;
}

const HeatmapLayer = ({
  locations,
  radius = 35,
  blur = 20,
  maxZoom = 18,
  max = 0.6,
  minOpacity = 0.4,
  gradient,
}: HeatmapLayerProps) => {
  const map = useMap();

  useEffect(() => {
    // Convert locations to heatmap points [lat, lng, intensity]
    // Using intensity of 1 for each point - the aggregation creates density
    const points: [number, number, number][] = locations.map(loc => [loc.lat, loc.lng, 1]);

    // Create heatmap layer with optimized settings for ~2600 points across US
    const heatLayer = (L as any).heatLayer(points, {
      radius,
      blur,
      maxZoom,
      max,
      minOpacity,
      gradient: gradient || {
        0.0: '#3B82F6', // blue - low density
        0.2: '#06B6D4', // cyan
        0.4: '#10B981', // green - medium-low
        0.6: '#F59E0B', // amber - medium
        0.8: '#F97316', // orange - medium-high
        1.0: '#EF4444', // red - high density
      },
    });

    heatLayer.addTo(map);

    // Cleanup on unmount or when locations change
    return () => {
      map.removeLayer(heatLayer);
    };
  }, [locations, map, radius, blur, maxZoom, max, minOpacity, gradient]);

  return null;
};

export default HeatmapLayer;
